import { Component, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import notify from 'devextreme/ui/notify';
import { AppConstants } from '../../../../../../core/constants/app-constants';

@Component({
  selector: 'edit-icon',
  templateUrl: './edit-icon.component.html',
  styleUrls: ['./edit-icon.component.scss'],
  standalone: false,
})
export class EditIconComponent implements OnInit {
  translate = inject(TranslateService);

  @Output('onFileAdded') public onFileAdded$ = new EventEmitter<File>();
  public files: File[] = [];

  public ngOnInit() {}

  public onValueChanged() {
    if (this.files.length && this.validateFiles(this.files)) {
      this.onFileAdded$.emit(this.files[0]);
    } else {
      this.onFileAdded$.emit(null);
    }
  }

  public getMaxIconSize(): number {
    return AppConstants.MaxIconSize;
  }

  public getSupportedIconFormats(): string[] {
    return AppConstants.SupportedIconFormats;
  }

  private validateFiles(files: File[]): boolean {
    var result = true;

    if (files) {
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        let fileExtension = file.name.substr(file.name.lastIndexOf('.')).toLowerCase();

        if (!AppConstants.SupportedIconFormats.includes(fileExtension)) {
          this.translate.get('NOT_SUPPORT_FILE_FORMAT').subscribe(value => {
            notify(value + file.name, 'error', 3000);
          });
          result = false;
          break;
        }

        if (file.size > AppConstants.MaxIconSize) {
          this.translate.get('EXCEEDED_FILE_SIZE').subscribe(value => {
            notify(value + file.name, 'error', 3000);
          });
          result = false;
          break;
        }
      }

      return result;
    }
  }
}
